import React from "react"

import Block, {
  BlockProps as BlogContent,
} from "../../page-components/blog/block"
import { StructuredTextBase } from "./structured-text-base"
import { StructuredTextProps } from "./types"

export function CmsArticleContent({ body }: StructuredTextProps) {
  return (
    <StructuredTextBase
      body={body}
      renderBlock={({ record }) => <Block {...(record as BlogContent)} />}
    />
  )
}
